var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('index-top')],1),_c('el-main',[_c('router-view',{key:_vm.key})],1),_c('el-footer',[_c('index-bottom')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }